"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFirestoreFieldValue = void 0;
var isFirestoreFieldValue = function (fieldValue) {
    var _a;
    return ((_a = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.wa) === null || _a === void 0 ? void 0 : _a.indexOf('FieldValue.')) > -1;
};
exports.isFirestoreFieldValue = isFirestoreFieldValue;
